module.exports = __webpack_public_path__ + "img/II-11.b30898a8.svg";